import { CreativeGuidelinesController } from './CreativeGuidelines.controller'
import { FC } from 'react'
import { PageTransition } from 'utils/animations'
import { useParams } from 'react-router-dom'

/**
 * Page rendering the in-platform CT/Admin "My guidelines" view.
 * Replaces the legacy Retool URL behind the ALLOW_CT_GUIDELINES_PAGE flag (ISSUE-1448).
 */
export const CreativeGuidelinesPage: FC = () => {
  const { productKind } = useParams<{ productKind?: string }>()

  return (
    <PageTransition>
      <CreativeGuidelinesController productKindFromPath={productKind || undefined} />
    </PageTransition>
  )
}
